// 省代订单管理
import { ServerDistApi } from '@/group-cloud/network/ServerBizApi';

export class hotScreenApi {

  constructor() {
  }

  //我的任务 查询列表
  public static async taskList(data) {
    return await ServerDistApi.send("/task/list", data);
  }

  //取消下载
  public static async cancelApi(data) {
    return await ServerDistApi.send("/task/close", data);
  }
  //订货单到任务列表
  public static async newOrde(data) {
    return await ServerDistApi.send("/ordering/export/newOrderDownload", data);
  }
}

